<div class="space"></div>

<!-- MAIN -->
<main>

    <!-- ARTICLE BLOG POST -->
    <section class="articles articles-blog-post">
        <article class="articles-blog-post" *ngFor="let data of datas; index as i">
            <div class="container">
                <div class="row">
                    <div class="col-lg-9 col-xs-12">

                        <!-- TEXT ARTICLE -->
                        <div class="articles-header">
                            <div class="box">
                                <time datetime="2016-10-11">{{ data.fecha | date:'dd/MM/yyyy' }}</time>
                                <span class="articles-header-tag-green">Nuevo</span>
                            </div>
                            <div class="box">
                                <a [routerLink]="['/categorias',data.category.name]">
                                    <div class="back">
                                        <img class="garrow" src="../../../../../assets/img/blog/detalles/g10arrow.svg" alt="volver">
                                        volver
                                    </div> 
                                </a>
                            </div>
                            
                        </div>
                        <div class="articles-content">
                            <h1 class="articles-content-blog-post-title"><a title="Tendencias de Transformacion Digital">{{ data.title }}</a></h1>

                            <div class="foto">

                                <img src="{{ data.image.url }}" alt="foto" width="100%"/>


                            </div>
                            
                            <p [innerHTML]="data.content">{{ data.content }}</p>

                            <div class="articles-content-block">

                            </div>
                        </div>
                    </div>


                    <!-- SHARE THIS BLOCK -->
                    <div class="col-lg-3 col-xs-12">
                        <div class="articles-blog-post-share">

                            <app-titulo></app-titulo>
<!--                             <h3>Compartir</h3>
                            <div>
                                <ul>
                                    <li><a href="#" title="Facebook"><i class="fa fa-facebook"></i>Facebook</a></li>
                                    <li><a href="#" title="Twitter"><i class="fa fa-twitter"></i>Twitter</a></li>
                                    <li><a href="#" title="Linkedin"><i class="fa fa-google-plus"></i>Linkedin</a></li>
                                </ul>
                            </div> -->
                        </div>
                    </div>

                </div>
            </div>
        </article>
    </section>
    <!-- end ARTICLE BLOG POST -->

    <!-- ARTICLE BOTTOM INFO -->
    <div class="articles-info">
       

    </div>
    <!-- end ARTICLE BOTTOM INFO -->


</main>
<!-- end MAIN -->

